import React, {useCallback, useEffect, useMemo, useState} from "react";
import GoogleMap from 'google-map-react';
import SiteMarker from "./SiteMarker";
import SiteCard from "./SiteCard";

const Salones = ({}) => {
    const defaultProps = {
        center: [18.255106587585377, -66.48016325000003],
        zoom: 9,
    };
    const [points, setPoints] = useState([]);
    const [tabSelected, setTabSelected] = useState('list');
    const [municipios, setMunicipios] = useState([]);
    const [municipio, setMunicipio] = useState();
    const [openCard, setOpenCard] = useState();
    const [selectedPoint, setSelectedPoint] = useState(undefined)

    const selectedPoints = useMemo(() => {
        if (municipio && municipio !== null && municipio !== 'Municipio') {
            return points.filter(p => p.municipio.toLowerCase().trim() === municipio.toLowerCase().trim())
        }
        return points;
    }, [points, municipio])

    useEffect(() => {
        fetch(process.env.REACT_APP_BASE_URL + '/blog/salones')
            .then(response => response.json())
            .then(data => {
                const ps = data.data.fields.salones.map(d => {
                    return {
                        ...d,
                        lat: Number(d.latitud),
                        lng: Number(d.longitud),
                        showCard: false
                    }
                })
                setPoints(ps)
                const municipios = data.data.fields.municipios.map(m => {
                    return m.nombre;
                })
                setMunicipios(municipios)
            })
            .catch(error => console.error(error));
    }, [])

    const center = useMemo(() => {
        let newCenter = defaultProps.center;
        if (selectedPoints && selectedPoints.length !== 0) {
            newCenter = selectedPoints
                .filter((s) => s.lat && s.lng)
                .reduce(
                    (accum, currVal) => {
                        return {
                            lat: Number(currVal.lat) + Number(accum.lat),
                            lng: Number(currVal.lng) + Number(accum.lng)
                        }
                    },
                    {lat: 0, lng: 0}
                )
            const size = selectedPoints.filter((s) => s.lat && s.lng).length;
            newCenter = {
                lat: newCenter.lat / size,
                lng: newCenter.lng / size
            }
        }
        if(selectedPoint !== undefined) {
            newCenter = selectedPoint
            newCenter = {
                lat: newCenter.lat,
                lng: newCenter.lng
            }
        }
        return newCenter;
    }, [points, municipio, selectedPoints, selectedPoint])

    const zoom = useMemo(() => {
        let newZoom = defaultProps.zoom
        if(selectedPoint !== undefined) {
            newZoom = 18;
        }
        console.log(newZoom)
        return newZoom;
    }, [selectedPoint])

    const setShowPoints = useCallback((point) => {
        const ps = points.map(p => {
            return {
                ...p,
                showCard: p === point && !point.showCard
            }
        })
        setPoints(ps)
    }, [points])

    useEffect(() => {
        console.log("sitios", points)
    }, [points])

    return <div id='salones' className="md:py-8 md:px-16 bg-gray-200">
        <div className="md:container md:mx-auto lg:px-20 md:pt-0 pt-8 bg-white">
            <div className="md:mx-0 mx-6 md:pt-8">
                <div className="text-right">
                    <select className="bg-black text-white p-3 w-full md:w-36 border-r-8 border-transparent"
                            onChange={(e) => {
                                setMunicipio(e.target.value)
                            }}>
                        <option value="Municipio">Municipio</option>
                        {municipios.map((m) => {
                            return <option value={m}>{m}</option>;
                        })
                        }
                    </select>
                </div>
                <div
                    className="grid grid-flow-col text-center border border-black border-1 mt-4 font-semibold md:hidden">
                    <div
                        className={`p-2 ${tabSelected == 'list' || tabSelected == '' ? 'bg-black text-white' : 'bg-white text-black'}`}
                        onClick={() => setTabSelected('list')}>VER LISTA
                    </div>
                    <div className={`p-2 ${tabSelected == 'map' ? 'bg-black text-white' : 'bg-white text-black'}`}
                         onClick={() => setTabSelected('map')}>VER MAPA
                    </div>
                </div>
            </div>
            <div className="flex flex-row justify-center h-120 my-4 md:pb-8">
                <div
                    className={`w-full md:w-1/4 max-h-120 px-4 pt-2 md:px-0 overflow-x-hidden ${tabSelected == 'map' ? 'hidden' : ''} md:block`}>
                    {selectedPoints.map((point) => {
                        return <SiteCard
                            name={point.nombre}
                            place={point.municipio}
                            phone={point.telefono}
                            address={point.direccion}
                            image={point.imagen}
                            web={point.web}
                            whatsapp={point.whatsapp}
                            instagram={point.instagram}
                            setOpenCard={setOpenCard}
                            openCard={openCard}
                            point={point}
                            setSelectedPoint={setSelectedPoint}
                        />
                    })}
                </div>
                <div className={`w-full md:mx-auto md:w-3/4 ${tabSelected == 'list' ? 'hidden' : ''} md:block`}>
                    <GoogleMap
                        bootstrapURLKeys={{key: "AIzaSyBWheGkO2ZkRmiqJQlhWa0asXhxyA2xyN8"}}
                        center={center}
                        zoom={zoom}
                        onClick={() => {
                            setShowPoints();
                        }}
                    >
                        {selectedPoints.map((point) => {
                            return <SiteMarker
                                lat={point.lat} lng={point.lng}
                                name={point.nombre}
                                address={point.direccion}
                                link={point.maps}
                                showCard={point.showCard}
                                setShowCard={() => {
                                    setShowPoints(point)
                                    setSelectedPoint(point)
                                }}
                            />
                        })}
                    </GoogleMap>
                </div>
            </div>
        </div>
    </div>
}

Salones.propTypes = {};

export default Salones;
